/* eslint-disable */
import { useNavigate, useParams } from "react-router-dom";
import settings from "../../../configs/settings";
import {
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Paper,
  TextField,
  Typography,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { DataGrid } from "@mui/x-data-grid";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useContext, useEffect, useState } from "react";
import { getGAsCobranza, saveCobranza } from "../../../project/services/CobranzaService";
import CobranzaContext from "../../../project/contexts/CobranzaContext";
import { Box } from "@mui/system";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import CobroEfectivo from "./CobroEfectivo";
import CobroTarjetaDebito from "./CobroTarjetaDebito";
import CobroTarjetaCredito from "./CobroTarjetaCredito";
import CobroTransferenciaBancaria from "./CobroTransferenciaBancaria";
import CobroBilletera from "./CobroBilletera";
import CobroCheque from "./CobroCheque";
import CobroOtro from "./CobroOtro";
import CobroDescuentoEspecial from "./CobroDescuentoEspecial";
import CobroObraSocial from "./CobroObraSocial";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
//
// ################################################################################
//
const GestionAtencionCobro = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [mediosDeCobroOptionsLocal, setMediosDeCobroOptionsLocal] = useState([]);
  const [disabledSaveCancelButtons, setDisabledSaveCancelButtons] = useState(false);
  const {
    message,
    setMessage,
    showMessage,
    setShowMessage,
    gestionesAtencion,
    setGestionesAtencion,
    setGestionesAtencionRows,
    totalGestionesAtencion,
    setTotalGestionesAtencion,
    totalPendienteCobro,
    setTotalPendienteCobro,
    setTotalPendienteCobroOriginal,
    setTotalPendienteCobroActual,
    totalCobrado,
    setTotalCobrado,
    restoACobrar,
    setRestoACobrar,
    expandedAccordionMediosDeCobro,
    setExpandedAccordionMediosDeCobro,
    mediosDeCobroOptions,
    valueACMedioDeCobro,
    setValueACMedioDeCobro,
    inputValueACMedioDeCobro,
    setInputValueACMedioDeCobro,
    mediosDeCobroTable,
    quitarMedioDeCobro,
    prepararCobranzaObject,
  } = useContext(CobranzaContext);

  const tableGAColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_creacion",
      headerName: "Fecha Creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_creacion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_cliente + " " + params.row.apellido_cliente;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "precio_venta_total",
      headerName: "Total",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.precio_venta_total + params.row.recargo;
        return _val.toFixed(2);
      },
    },
    {
      field: "pendiente_pago_total",
      headerName: "Saldo",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.pendiente_pago_total + params.row.recargo;
        return _val.toFixed(2);
      },
    },
    {
      field: "descripcion_corta_area",
      headerName: "Sucursal",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "username",
      headerName: "Vendedor",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
  ];

  const tableMDCColumns = [
    {
      field: "tipoCobro",
      headerName: "Tipo de Cobro",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tipoCobro;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "detalleMedioDeCobro",
      headerName: "Detalle del medio de cobro",
      headerAlign: "center",
      align: "left",
      flex: 6,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.detalleMedioDeCobro;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "importe",
      headerName: "Importe",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe + params.row.importeRecargo;
        return _val.toFixed(2);
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.borrable ? (
            <>
              <Tooltip title="Quitar">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => quitarMedioDeCobro(params.row)}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            </>
          ) : null}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    const load = async () => {
      setIsDoingSomething(true);
      const response = await getGAsCobranza(JSON.parse(params.arrayGAs));
      setIsDoingSomething(false);

      if (response.ok) {
        // arreglo de las gestiones de atencion seleccionadas para cobrar
        let _gestionesAtencion = response.data.data.gc;
        // arreglo de las filas de productos de las gestiones de atencion seleccionadas para cobrar
        let _gestionesAtencionRows = response.data.data.rows_gc;
        let _totalGestionesAtencion = 0;
        let _totalPendienteCobro = 0;

        _gestionesAtencion.forEach((item) => {
          _totalGestionesAtencion += item.precio_venta_total;
          _totalPendienteCobro += item.pendiente_pago_total;
          item.recargo = 0;
        });

        _gestionesAtencionRows.forEach((item) => {
          item.pendiente_pago_original = item.pendiente_pago;
          item.recargo = 0;
          item.descuento_total = 0;
          item.descuento_proporcional = 0;
        });

        setGestionesAtencion(_gestionesAtencion);
        setGestionesAtencionRows(_gestionesAtencionRows);
        setTotalGestionesAtencion(_totalGestionesAtencion);
        setTotalPendienteCobro(_totalPendienteCobro);
        setTotalPendienteCobroOriginal(_totalPendienteCobro);
        setTotalPendienteCobroActual(_totalPendienteCobro);
        setTotalCobrado(0);
        setRestoACobrar(_totalPendienteCobro);

        if (_gestionesAtencion[0].particular_osocial === "particular") {
          // si se ha seleccionado al menos una ga particular
          // quito la opcion de cobro con obra social
          setMediosDeCobroOptionsLocal(
            mediosDeCobroOptions.filter((item) => {
              return item.id !== "obra-social";
            })
          );
        } else {
          // si la ga seleccionada para cobrar es de obra social
          setMediosDeCobroOptionsLocal(mediosDeCobroOptions);
        }
      } else {
        setGestionesAtencion([]);
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };

    load();
  }, []);
  //
  // ################################################################################
  //
  const handleCancel = () => {
    window.close();
    // navigate("/gestion-atencion-table");
    // return;
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    // validaciones

    if (gestionesAtencion.length === 0) {
      // si no hay ga seleccionadas para cobrar

      setMessage({
        severity: "error",
        messageText: "Debes seleccionar Gestiones de Atención para cobrar",
      });
      setShowMessage(true);
      return;
    }

    if (totalGestionesAtencion <= 0) {
      // si el importe total de las ga seleccionadas para cobrar no es mayor a 0

      setMessage({
        severity: "error",
        messageText: "El total a cobrar debe ser mayor a cero",
      });
      setShowMessage(true);
      return;
    }

    if (totalPendienteCobro <= 0) {
      // si el importe total pendiente de cobro de las ga seleccionadas para cobrar no es mayor a 0

      setMessage({
        severity: "error",
        messageText: "El total pendiente de cobro debe ser mayor a cero",
      });
      setShowMessage(true);
      return;
    }

    if (mediosDeCobroTable.length === 0) {
      // si no hay mdc agregados a la cobranza

      setMessage({
        severity: "error",
        messageText: "Debes agregar medios de cobro para poder guardar la cobranza",
      });
      setShowMessage(true);
      return;
    }

    if (totalCobrado <= 0) {
      // si el importe total cobrado no es mayor a 0

      setMessage({
        severity: "error",
        messageText: "El total cobrado debe ser mayor a cero",
      });
      setShowMessage(true);
      return;
    }

    if (restoACobrar < 0) {
      // si el importe pendiente de cobro actual no es mayor o igual a 0

      setMessage({
        severity: "error",
        messageText: "El nuevo importe pendiente de cobro debe ser mayor o igual a cero",
      });
      setShowMessage(true);
      return;
    }

    let _cobranza = prepararCobranzaObject();

    save(_cobranza);
  };
  //
  // ################################################################################
  //
  const save = async (parCobranza) => {
    setDisabledSaveCancelButtons(true);

    setIsDoingSomething(true);
    const response = await saveCobranza("new", parCobranza);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        navigate("/gestion-atencion-table");
      }, 2000);
    } else {
      setDisabledSaveCancelButtons(false);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={2} sx={{ p: 2, m: 2, width: "100%" }}>
        <Typography variant="h5" display="block" gutterBottom>
          Cobranza
        </Typography>
        <Box sx={{ p: 1 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Gestión de Atención a cobrar
          </Typography>
          <DataGrid
            rows={gestionesAtencion}
            columns={tableGAColumns}
            {...tableOptions}
          />
        </Box>

        <Box sx={{ m: 2, ml: 0, mb: 0 }}>
          <Grid container>
            <Grid item xs={12} sm={12} md={4} lg={2}>
              <TextField
                sx={{ width: "100%", m: 1, p: 1 }}
                inputProps={{ style: { textAlign: "right" } }}
                id="totalGestionesAtencion"
                label="Total GA"
                variant="outlined"
                size="small"
                name="totalGestionesAtencion"
                value={totalGestionesAtencion.toLocaleString(
                  settings.numericLocales.language,
                  settings.numericLocales.options
                )}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={2}>
              <TextField
                sx={{ width: "100%", m: 1, p: 1 }}
                inputProps={{ style: { textAlign: "right" } }}
                id="totalPendienteCobro"
                label="Pendiente de cobro actual"
                variant="outlined"
                size="small"
                name="totalPendienteCobro"
                value={totalPendienteCobro.toLocaleString(
                  settings.numericLocales.language,
                  settings.numericLocales.options
                )}
                disabled={true}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ borderRadius: "5px", p: 2 }}>
          <Accordion
            expanded={expandedAccordionMediosDeCobro}
            onChange={() => setExpandedAccordionMediosDeCobro(!expandedAccordionMediosDeCobro)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="cristales"
              sx={{
                backgroundColor: 'rgba(25, 118, 210, 0.08)', // azul sutil
                borderRadius: 2,
                '&:before': {
                  display: 'none', // elimina la línea gris superior
                },
              }}
            >
              <Typography component={"span"} variant={"body1"}>
                Seleccioná los medios de cobro
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
              <Grid container>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <Autocomplete
                    size="small"
                    sx={{ width: "90%", p: 1, m: 1 }}
                    value={valueACMedioDeCobro}
                    onChange={(event, newValue) => {
                      setValueACMedioDeCobro(newValue);
                    }}
                    inputValue={inputValueACMedioDeCobro}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACMedioDeCobro(newInputValue);
                    }}
                    options={mediosDeCobroOptionsLocal}
                    renderInput={(params) => <TextField {...params} label="Medio de Cobro" />}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8}>

                  {valueACMedioDeCobro !== null && valueACMedioDeCobro.id === "efectivo" && <CobroEfectivo />}

                  {valueACMedioDeCobro !== null && valueACMedioDeCobro.id === "tarjeta-debito" && <CobroTarjetaDebito />}

                  {valueACMedioDeCobro !== null && valueACMedioDeCobro.id === "tarjeta-credito" && (
                    <CobroTarjetaCredito />
                  )}

                  {valueACMedioDeCobro !== null && valueACMedioDeCobro.id === "transferencia-bancaria" && (
                    <CobroTransferenciaBancaria />
                  )}

                  {valueACMedioDeCobro !== null && valueACMedioDeCobro.id === "billetera-virtual" && <CobroBilletera />}

                  {valueACMedioDeCobro !== null && valueACMedioDeCobro.id === "cheque" && <CobroCheque />}

                  {valueACMedioDeCobro !== null && valueACMedioDeCobro.id === "otro" && <CobroOtro />}

                  {valueACMedioDeCobro !== null && valueACMedioDeCobro.id === "descuento-especial" && (
                    <CobroDescuentoEspecial />
                  )}

                  {valueACMedioDeCobro !== null && valueACMedioDeCobro.id === "obra-social" && <CobroObraSocial />}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Box>

        <Box sx={{ p: 1 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Medios de cobro
          </Typography>
          <DataGrid
            rows={mediosDeCobroTable}
            columns={tableMDCColumns}
            {...tableOptions}
          />
        </Box>

        <Box sx={{ m: 2, ml: 0, mb: 0 }}>
          <Grid container>
            <Grid item xs={12} sm={12} md={4} lg={2}>
              <TextField
                sx={{ width: "100%", m: 1, p: 1 }}
                inputProps={{ style: { textAlign: "right" } }}
                id="totalCobrado"
                label="Total cobrado "
                variant="outlined"
                size="small"
                name="totalCobrado"
                value={totalCobrado.toLocaleString(
                  settings.numericLocales.language,
                  settings.numericLocales.options
                )}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={2}>
              <TextField
                sx={{ width: "100%", m: 1, p: 1 }}
                inputProps={{ style: { textAlign: "right" } }}
                id="restoACobrar"
                label="Resto a cobrar"
                variant="outlined"
                size="small"
                name="restoACobrar"
                value={restoACobrar.toLocaleString(
                  settings.numericLocales.language,
                  settings.numericLocales.options
                )}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Button
            sx={{ m: 1 }}
            variant="contained"
            onClick={handleSave}
            disabled={disabledSaveCancelButtons}
            startIcon={<SaveIcon />}
          >
            Guardar Cobranza
          </Button>

          <Button
            sx={{ m: 1 }}
            variant="outlined"
            onClick={handleCancel}
            disabled={disabledSaveCancelButtons}
            startIcon={<CancelIcon />}
          >
            Cancelar
          </Button>
        </Box>
      </Paper>

      {/* >>>> Messages */}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default GestionAtencionCobro;
